import { render } from "./CondimentTray.vue?vue&type=template&id=156c4571&scoped=true"
import script from "./CondimentTray.vue?vue&type=script&lang=js"
export * from "./CondimentTray.vue?vue&type=script&lang=js"

import "./CondimentTray.vue?vue&type=style&index=0&id=156c4571&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156c4571"]])

export default __exports__